import React, { useState, useEffect, useMemo, useCallback } from 'react';
import '../../styles/Counter.css';
import { t, translateLocation } from '../../services/LanguageTranslationService';

// Memoized location data
const LOCATION_DATA = [
  {
    "division": "Amravati",
    "districts": [
      {
        "name": "Akola",
        "branchOffices": [
          "Akola"
        ]
      },
      {
        "name": "Amravati",
        "branchOffices": [
          "Amravati"
        ]
      },
      {
        "name": "Buldhana",
        "branchOffices": [
          "Buldhana"
        ]
      },
      {
        "name": "Washim",
        "branchOffices": [
          "Washim"
        ]
      },
      {
        "name": "Yavatmal",
        "branchOffices": [
          "Yavatmal"
        ]
      }
    ]
  },
  {
    "division": "Chhatrapati Sambhaji Nagar",
    "districts": [
      {
        "name": "Beed",
        "branchOffices": [
          "Beed"
        ]
      },
      {
        "name": "Chhatrapati Sambhaji Nagar",
        "branchOffices": [
          "Chhatrapati Sambhaji Nagar"
        ]
      },
      {
        "name": "Dharashiv",
        "branchOffices": [
          "Dharashiv"
        ]
      },
      {
        "name": "Hingoli",
        "branchOffices": [
          "Hingoli"
        ]
      },
      {
        "name": "Jalna",
        "branchOffices": [
          "Jalna"
        ]
      },
      {
        "name": "Latur",
        "branchOffices": [
          "Latur"
        ]
      },
      {
        "name": "Nanded",
        "branchOffices": [
          "Nanded"
        ]
      },
      {
        "name": "Parbhani",
        "branchOffices": [
          "Parbhani"
        ]
      }
    ]
  },
  {
    "division": "Kokan",
    "districts": [
      {
        "name": "Palghar",
        "branchOffices": [
          "Palghar"
        ]
      },
      {
        "name": "Raigad",
        "branchOffices": [
          "Raigad"
        ]
      },
      {
        "name": "Ratnagiri",
        "branchOffices": [
          "Ratnagiri"
        ]
      },
      {
        "name": "Sindhudurg",
        "branchOffices": [
          "Sindhudurg"
        ]
      },
      {
        "name": "Thane",
        "branchOffices": [
          "Thane"
        ]
      }
    ]
  },
  {
    "division": "Nagpur",
    "districts": [
      {
        "name": "Bhandara",
        "branchOffices": [
          "Bhandara"
        ]
      },
      {
        "name": "Chandrapur",
        "branchOffices": [
          "Chandrapur"
        ]
      },
      {
        "name": "Gadchiroli",
        "branchOffices": [
          "Gadchiroli"
        ]
      },
      {
        "name": "Gondia",
        "branchOffices": [
          "Gondia"
        ]
      },
      {
        "name": "Nagpur",
        "branchOffices": [
          "Nagpur"
        ]
      },
      {
        "name": "Wardha",
        "branchOffices": [
          "Wardha"
        ]
      }
    ]
  },
  {
    "division": "Nashik",
    "districts": [
      {
        "name": "Ahilyanagar",
        "branchOffices": [
          "Ahilyanagar",
          "Shrirampur"
        ]
      },
      {
        "name": "Dhule",
        "branchOffices": [
          "Dhule"
        ]
      },
      {
        "name": "Jalgaon",
        "branchOffices": [
          "Jalgaon"
        ]
      },
      {
        "name": "Nandurbar",
        "branchOffices": [
          "Nandurbar"
        ]
      },
      {
        "name": "Nashik",
        "branchOffices": [
          "Nashik"
        ]
      }
    ]
  },
  {
    "division": "Pune",
    "districts": [
      {
        "name": "Kolhapur",
        "branchOffices": [
          "Kolhapur"
        ]
      },
      {
        "name": "Pune",
        "branchOffices": [
          "Baramati Branch",
          "Pune"
        ]
      },
      {
        "name": "Sangli",
        "branchOffices": [
          "Sangli"
        ]
      },
      {
        "name": "Satara",
        "branchOffices": [
          "Satara"
        ]
      },
      {
        "name": "Solapur",
        "branchOffices": [
          "Solapur"
        ]
      }
    ]
  }

];


const BASE_COUNTS = {
  divisions: 6,
  districts: 34,
  branchOffices: 36,
  village: 45000,
  ApplicationReceived: 0,
  ApplicationRejected: 0,
  ApplicationApproved: 0,
  MaximumDaytaken: 0,
  MinimumDaytaken: 0,
  AvgTimeDisposule: 0, // Ensure this is a number
  CompliancePercentage: 0,
  "Service Charges": 0
};

const Counter = () => {
  const [counts, setCounts] = useState(BASE_COUNTS);
  const [selectedDivision, setSelectedDivision] = useState('Pune');
  const [selectedDistrict, setSelectedDistrict] = useState('Sangli');
  const [selectedBranchOffice, setSelectedBranchOffice] = useState('Sangli');
  const [selectedServiceType, setSelectedServiceType] = useState('');
  const [serverData, setServerData] = useState(null);
  const [loading, setLoading] = useState(false);


  // Flatten the data only once
  const flattenedLocationData = useMemo(() =>
    LOCATION_DATA.flatMap(division =>
      division.districts.flatMap(district =>
        district.branchOffices.map(branch => ({
          division: division.division,
          district: district.name,
          branchOffice: branch
        }))
      )
    ),
    []
  );

  // Memoized divisions
  const divisions = useMemo(
    () => [...new Set(flattenedLocationData.map(item => item.division))],
    [flattenedLocationData]
  );

  // Memoized districts based on selected division
  const districts = useMemo(() => {
    if (!selectedDivision) return [];
    return [...new Set(
      flattenedLocationData
        .filter(item => item.division === selectedDivision)
        .map(item => item.district)
    )];
  }, [selectedDivision, flattenedLocationData]);

  // Memoized branch offices based on selected district
  const branchOffices = useMemo(() => {
    if (!selectedDistrict) return [];
    return [...new Set(
      flattenedLocationData
        .filter(item => item.district === selectedDistrict)
        .map(item => item.branchOffice)
    )];
  }, [selectedDistrict, flattenedLocationData]);



  // Event handlers
  const handleDivisionChange = useCallback((e) => {
    setSelectedDivision(e.target.value);
    setSelectedDistrict('');
    setSelectedBranchOffice('');
  }, []);

  const handleDistrictChange = useCallback((e) => {
    setSelectedDistrict(e.target.value);
    setSelectedBranchOffice('');
  }, []);

  const handleBranchOfficeChange = useCallback((e) => {
    setSelectedBranchOffice(e.target.value);
  }, []);

  const handleServiceTypeChange = useCallback((e) => {
    setSelectedServiceType(e.target.value);
  }, []);





  useEffect(() => {

    if (!serverData) return;
    // Calculate other stats based on your business logic

    if (selectedServiceType == 'All') {

      const compliancePercentage = serverData.data.ApplicationReceived > 0
        ? Math.round((serverData.data.ApplicationApproved / (serverData.data.ApplicationReceived - serverData.data.ApplicationRejected)) * 100)
        : 0;
      const serviceCharges = serverData.data.ApplicationReceived * 250;

      setCounts(prev => ({
        ...prev,
        ...serverData.data,
        ApplicationApproved: serverData.data.ApplicationApproved,
        ApplicationRejected: serverData.data.ApplicationRejected,
        MaximumDaytaken: serverData.data.MaximumDaytaken,
        //MinimumDaytaken: serverData.data.MinimumDaytaken,
        MinimumDaytaken: "1",
        ApplicationReceived: serverData.data.ApplicationReceived,
        CompliancePercentage: compliancePercentage,
        "Service Charges": serviceCharges,
        // Keep the non-application related counts
        divisions: selectedDivision ? 1 : prev.divisions,
        districts: selectedDistrict ? 1 : prev.districts,
        branchOffices: selectedBranchOffice ? 1 :
          selectedDistrict ? branchOffices.length :
            selectedDivision ? flattenedLocationData.filter(item => item.division === selectedDivision).length :
              prev.branchOffices,
        village: prev.village // Keep village count as is or fetch from API if available
      }));

    }

    if (selectedServiceType == 'Part') {

      const compliancePercentage = serverData.data.recived_Part_applications > 0
        ? Math.round((serverData.data.approved_Part_applications / (serverData.data.recived_Part_applications - serverData.data.rejected_Part_applications)) * 100)
        : 0;
      const serviceCharges = serverData.data.recived_Part_applications * 250;

      setCounts(prev => ({
        ...prev,
        ...serverData.data,
        ApplicationApproved: serverData.data.approved_Part_applications,
        ApplicationRejected: serverData.data.rejected_Part_applications,
        MaximumDaytaken: serverData.data.max_days_part,
        //MinimumDaytaken: serverData.data.min_days_part,
        MinimumDaytaken: "1",
        ApplicationReceived: serverData.data.recived_Part_applications,
        CompliancePercentage: compliancePercentage,
        "Service Charges": serviceCharges,
        // Keep the non-application related counts
        divisions: selectedDivision ? 1 : prev.divisions,
        districts: selectedDistrict ? 1 : prev.districts,
        branchOffices: selectedBranchOffice ? 1 :
          selectedDistrict ? branchOffices.length :
            selectedDivision ? flattenedLocationData.filter(item => item.division === selectedDivision).length :
              prev.branchOffices,
        village: prev.village // Keep village count as is or fetch from API if available
      }));

    }

    if (selectedServiceType == 'Zone') {

      const compliancePercentage = serverData.data.recived_Zone_applications > 0
        ? Math.round((serverData.data.approved_Zone_applications / (serverData.data.recived_Zone_applications - serverData.data.rejected_Zone_applications )) * 100)
        : 0;
      const serviceCharges = serverData.data.recived_Zone_applications * 250;
      setCounts(prev => ({
        ...prev,
        ...serverData.data,
        ApplicationApproved: serverData.data.approved_Zone_applications,
        ApplicationRejected: serverData.data.rejected_Zone_applications,
        MaximumDaytaken: serverData.data.max_days_zone,
        //MinimumDaytaken: serverData.data.min_days_zone,
        MinimumDaytaken: "1",
        ApplicationReceived: serverData.data.recived_Zone_applications,
        CompliancePercentage: compliancePercentage,
        "Service Charges": serviceCharges,
        // Keep the non-application related counts
        divisions: selectedDivision ? 1 : prev.divisions,
        districts: selectedDistrict ? 1 : prev.districts,
        branchOffices: selectedBranchOffice ? 1 :
          selectedDistrict ? branchOffices.length :
            selectedDivision ? flattenedLocationData.filter(item => item.division === selectedDivision).length :
              prev.branchOffices,
        village: prev.village // Keep village count as is or fetch from API if available
      }));

    }

  }, [selectedServiceType]);



  // Format number with commas
  const formatNumber = useCallback((num) => {
    if (typeof num === 'string') return num;
    return num.toLocaleString();
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      try {
        // Build query params
        const params = new URLSearchParams();
        if (selectedDivision) params.append('division', selectedDivision);
        if (selectedDistrict) params.append('district', selectedDistrict);
        if (selectedBranchOffice) params.append('branch', selectedBranchOffice);

        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/headOffice_count_api.php?${params.toString()}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();

        if (data.status === 'success') {

          setServerData(data);

          // Calculate other stats based on your business logic
          const compliancePercentage = data.data.ApplicationReceived > 0
            ? Math.round((data.data.ApplicationApproved / (data.data.ApplicationReceived - data.data.ApplicationRejected)) * 100)
            : 0;

          const serviceCharges = data.data.ApplicationReceived * 250;

          setCounts(prev => ({
            ...prev,
            ...data.data,
            CompliancePercentage: compliancePercentage,
            "Service Charges": serviceCharges,
            // Keep the non-application related counts
            divisions: selectedDivision ? 1 : prev.divisions,
            districts: selectedDistrict ? 1 : prev.districts,
            branchOffices: selectedBranchOffice ? 1 :
              selectedDistrict ? branchOffices.length :
                selectedDivision ? flattenedLocationData.filter(item => item.division === selectedDivision).length :
                  prev.branchOffices,
            village: prev.village // Keep village count as is or fetch from API if available
          }));
        }
      } catch (error) {
        console.error('Error fetching stats:', error);
        // Optionally show error to user
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [selectedDivision, selectedDistrict, selectedBranchOffice, branchOffices.length, flattenedLocationData]);




  return (
    <section id="stats" className="stats-section">
      <div className="section-container">
        <h2 className="section-title">{t('stats.title')}</h2>

        <div className="dropdown-container">
          <div className="dropdown-wrapper">
            <select
              value={selectedDivision}
              onChange={handleDivisionChange}
              className="location-dropdown"
                  disabled

            >
              <option value="">{t('stats.selectDivision')}</option>
              {divisions.map(division => (
                <option key={division} value={division}>
                  {translateLocation('divisions', division)}
                </option>
              ))}
            </select>
          </div>

          <div className="dropdown-wrapper">
            <select
              value={selectedDistrict}
              onChange={handleDistrictChange}
              className="location-dropdown"
              disabled={selectedDivision}
            >
              <option value="">{t('stats.selectDistrict')}</option>
              {districts.map(district => (
                <option key={district} value={district}>
                  {translateLocation('districts', district)}
                </option>
              ))}
            </select>
          </div>



          <div className="dropdown-wrapper">
            <select
              value={selectedBranchOffice}
              onChange={handleBranchOfficeChange}
              className="location-dropdown"
              disabled={selectedDistrict}
            >
              <option value="">{t('stats.selectBranchOffice')}</option>
              {branchOffices.map(office => (
                <option key={office} value={office}>
                  {translateLocation('branchOffices', office)}
                </option>
              ))}
            </select>
          </div>

          <div className="dropdown-wrapper">
            <select
              value={selectedServiceType}
              onChange={handleServiceTypeChange}
              className="location-dropdown"

            >
              <option value="">Service Type</option>

              <option key="All" value="All">
                All
              </option>
              <option key="Part" value="Part">
                Part Plan
              </option>
              <option key="Zone" value="Zone">
                Zone
              </option>

            </select>
          </div>
        </div>


        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">{formatNumber(counts.divisions)}</div>
            <div className="stat-label">{t('stats.divisions')}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{formatNumber(counts.districts)}</div>
            <div className="stat-label">{t('stats.districts')}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{formatNumber(counts.branchOffices)}</div>
            <div className="stat-label">{t('stats.branchOffices')}</div>
          </div>
        </div>

        <div className="stats-grid">


          <div className="stat-card">
            <div className="stat-number-d">{formatNumber(counts.ApplicationReceived)}</div>
            <div className="stat-label-d">{t('stats.ApplicationReceived')}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number-d">{formatNumber(counts.ApplicationApproved)}</div>
            <div className="stat-label-d">{t('stats.ApplicationApproved')}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number-d">{formatNumber(counts.ApplicationRejected)}</div>
            <div className="stat-label-d">{t('stats.ApplicationRejected')}</div>
          </div>
        </div>

        <div className="stats-grid">

          <div className="stat-card">
            <div className="stat-number-d">{formatNumber(counts.MaximumDaytaken)}</div>
            <div className="stat-label-d">{t('stats.MaximumDataken')}</div>
          </div>

          <div className="stat-card">
            <div className="stat-number-d">{formatNumber(counts.MinimumDaytaken)}</div>
            <div className="stat-label-d">{t('stats.MinimumDaytaken')}</div>
          </div>
        </div>


        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number-d">{formatNumber(counts.CompliancePercentage)}%</div>
            <div className="stat-label-d">{t('stats.CompliancePercentage')}</div>
          </div>

          <div className="stat-card">
            <div className="stat-number-d">{formatNumber(counts.AvgTimeDisposule)} days</div>
            <div className="stat-label-d">{t('stats.AvgTimeDisposule')}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number-d">₹{formatNumber(counts["Service Charges"])}</div>
            <div className="stat-label-d">{t('stats.Service Charges')}</div>
          </div>
        </div>


      </div>
    </section>
  );
};

export default React.memo(Counter);